import Handlebars from "handlebars";
import {t} from "@lingui/core/macro";

export default () => Handlebars.compile(`<div id="achievements" class="{{#if fStandardView}}standard-view{{else}}mobile-view{{/if}}">
  <div id="achievement-list">
    <div class="pure-g pure-g--gutter">
      <ul class="badge-category-list">
        {{#each reversedBadgeCollections}}
          <li class="badge-category {{toBadgeClassName category}} {{#if userBadges.length}}owned{{/if}} pure-u-1-3 pure-u-md-1-6" data-category="category-{{category}}">
            <a id="category-{{category}}-trigger" href="#" class="badge-category-trigger">
              <img alt="{{toBadgeLabel category ../fStandardView true}}" class="badge-category-image" src="{{toMediumIconSrc category}}" />
              <div aria-hidden="true" class="achievement-label">
                {{toBadgeLabel category ../fStandardView true}}
              </div>
            </a>
          </li>
        {{/each}}
      </ul>
    </div>
    <div id="update-badges-container">
      {{#if userIsLoggedIn}}
        <button id="update-badges">${t`Check for new badges and avatars`}</button>
      {{/if}}
    </div>
    <div id="badge-container" class="inset-container single-category" style="display: none;">
      {{#each badgeCollections}}
          <div id="category-{{category}}" style="display: none;">
            <h2 class="category-header">{{toBadgeLabel category ../fStandardView true}}</h2>
            <div class="badge-description-container">
              <div class="badge-description-content">
                  {{categoryDescription}}
              </div>
            </div>
            {{#if userBadges.length}}
            <div id="user-owned" class="user-owned-container">
              <div class="pure-g pure-g--gutter">
                {{#each userBadges}}
                <div class="pure-u-1 pure-u-sm-1-2 pure-u-{{../../breakpoint}}-1-3">
                  <a class="badge-link" href="/badges/{{ badge.slug }}">
                    <div class="achievement-badge category-{{category}} {{#if badge.isOwned}}achievement-badge-owned{{/if}}" title="{{badge.translatedExtendedDescription}}">
                        <div id="outline-box">
                        <div class="badge-image-and-count">
                            <img src="{{staticUrl badge.iconSrc}}" id="badge-icon"/>
                            {{#if hasMultiple}}
                              <div class="achievement-count">&times;{{count}}</div>
                            {{/if}}
                        </div>
                        <div class="achievement-text">
                        <div class="achievement-title">{{badge.translatedDescription}}</div>
                        <div class="achievement-desc">
                            {{#if badge.isRetired}}
                              {{! Warning: changing indentation within i18n strings will alter translation keys. }}
                              ${t`This badge has been <span class="badge-context-retired">retired</span>!
                            You get to keep it forever, but nobody else can earn it.`}
                            {{else if badge.isOwned}}
                              {{#if lastEarnedDate}}
                                {{getTimeAgo lastEarnedDate}}
                              {{/if}}
                            {{else}}
                              {{badge.translatedExtendedDescription}}
                            {{/if}}
                        </div>
                        </div>
                        {{#if badge.points}}<div class="energy-points-badge">{{badge.points}}</div>{{/if}}
                        </div>
                      </div>
                    </a>
                  </div>
                {{/each}}
              </div>
            </div>
            {{/if}}
          </div>
      {{/each}}

    </div>
  </div>
</div>`) as any;
